const Services = 
[
    'Proofreading',
    'Interpretation (consecutive)',
    'Interpretation (simultaneous)',
    'Subtitling',
    'Voice-over',
    'Project Management',
    'Copywriting',
    'DTP',
    'Programming',
    'Web-Design',
    'Advertising',
    'Tour Guiding',
    'Market Research',
    'Consulting',
    'Teaching (Language Courses)',
    'SEO'
]

export default Services